import { queryPathBuilder } from '../../util/queryPathBuilder';
import {
  GET_COSMETIC_COMMISSIONS
} from '../types';
import { get } from './Action';

const basePath = 'cosmetic-commission';

// Get Cosmetic Commissions
export const getCosmeticCommissions = (params) => async (dispatch) => {
  const queryParams = queryPathBuilder(params);
  return await dispatch(
    get(`${basePath}${queryParams}`, getCosmeticCommissionsDS, true)
  );
};

const getCosmeticCommissionsDS = (commissions) => ({
  type: GET_COSMETIC_COMMISSIONS,
  payload: commissions.items,
});
